// extracted by mini-css-extract-plugin
module.exports = {"numberInput":"cleaning-setting_numberInput_3rLeb","tipText":"cleaning-setting_tipText_2WCpX"};